import { useMemo } from "react";

import { Logger } from "logging/logger";

export const useLogger = (prefix) => {
  const logger = useMemo(() => {
    return new Logger(prefix);
  }, [prefix]);

  return logger;
};
